export const environment = {
    base_url: 'https://api-demo.clickbo.net/api/v1',
    // base_url: 'http://localhost:8002/api/v1',
    inspection: false, //solo en true, mostrar emision
};
